"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationCountryHelpers = exports.ApplicationCountry = void 0;
var ApplicationCountry;
(function (ApplicationCountry) {
    ApplicationCountry["AE"] = "AE";
    ApplicationCountry["AG"] = "AG";
    ApplicationCountry["AI"] = "AI";
    ApplicationCountry["AL"] = "AL";
    ApplicationCountry["AM"] = "AM";
    ApplicationCountry["AO"] = "AO";
    ApplicationCountry["AR"] = "AR";
    ApplicationCountry["AT"] = "AT";
    ApplicationCountry["AU"] = "AU";
    ApplicationCountry["AZ"] = "AZ";
    ApplicationCountry["BB"] = "BB";
    ApplicationCountry["BE"] = "BE";
    ApplicationCountry["BF"] = "BF";
    ApplicationCountry["BG"] = "BG";
    ApplicationCountry["BH"] = "BH";
    ApplicationCountry["BJ"] = "BJ";
    ApplicationCountry["BM"] = "BM";
    ApplicationCountry["BN"] = "BN";
    ApplicationCountry["BO"] = "BO";
    ApplicationCountry["BR"] = "BR";
    ApplicationCountry["BS"] = "BS";
    ApplicationCountry["BT"] = "BT";
    ApplicationCountry["BW"] = "BW";
    ApplicationCountry["BY"] = "BY";
    ApplicationCountry["BZ"] = "BZ";
    ApplicationCountry["CA"] = "CA";
    ApplicationCountry["CG"] = "CG";
    ApplicationCountry["CH"] = "CH";
    ApplicationCountry["CL"] = "CL";
    ApplicationCountry["CN"] = "CN";
    ApplicationCountry["CO"] = "CO";
    ApplicationCountry["CR"] = "CR";
    ApplicationCountry["CV"] = "CV";
    ApplicationCountry["CY"] = "CY";
    ApplicationCountry["CZ"] = "CZ";
    ApplicationCountry["DE"] = "DE";
    ApplicationCountry["DK"] = "DK";
    ApplicationCountry["DM"] = "DM";
    ApplicationCountry["DO"] = "DO";
    ApplicationCountry["DZ"] = "DZ";
    ApplicationCountry["EC"] = "EC";
    ApplicationCountry["EE"] = "EE";
    ApplicationCountry["EG"] = "EG";
    ApplicationCountry["ES"] = "ES";
    ApplicationCountry["FI"] = "FI";
    ApplicationCountry["FJ"] = "FJ";
    ApplicationCountry["FM"] = "FM";
    ApplicationCountry["FR"] = "FR";
    ApplicationCountry["GB"] = "GB";
    ApplicationCountry["GD"] = "GD";
    ApplicationCountry["GH"] = "GH";
    ApplicationCountry["GM"] = "GM";
    ApplicationCountry["GR"] = "GR";
    ApplicationCountry["GT"] = "GT";
    ApplicationCountry["GW"] = "GW";
    ApplicationCountry["GY"] = "GY";
    ApplicationCountry["HK"] = "HK";
    ApplicationCountry["HN"] = "HN";
    ApplicationCountry["HR"] = "HR";
    ApplicationCountry["HU"] = "HU";
    ApplicationCountry["ID"] = "ID";
    ApplicationCountry["IE"] = "IE";
    ApplicationCountry["IL"] = "IL";
    ApplicationCountry["IN"] = "IN";
    ApplicationCountry["IS"] = "IS";
    ApplicationCountry["IT"] = "IT";
    ApplicationCountry["JM"] = "JM";
    ApplicationCountry["JO"] = "JO";
    ApplicationCountry["JP"] = "JP";
    ApplicationCountry["KE"] = "KE";
    ApplicationCountry["KG"] = "KG";
    ApplicationCountry["KH"] = "KH";
    ApplicationCountry["KN"] = "KN";
    ApplicationCountry["KR"] = "KR";
    ApplicationCountry["KW"] = "KW";
    ApplicationCountry["KY"] = "KY";
    ApplicationCountry["KZ"] = "KZ";
    ApplicationCountry["LA"] = "LA";
    ApplicationCountry["LB"] = "LB";
    ApplicationCountry["LC"] = "LC";
    ApplicationCountry["LK"] = "LK";
    ApplicationCountry["LR"] = "LR";
    ApplicationCountry["LT"] = "LT";
    ApplicationCountry["LU"] = "LU";
    ApplicationCountry["LV"] = "LV";
    ApplicationCountry["MD"] = "MD";
    ApplicationCountry["MG"] = "MG";
    ApplicationCountry["MK"] = "MK";
    ApplicationCountry["ML"] = "ML";
    ApplicationCountry["MN"] = "MN";
    ApplicationCountry["MO"] = "MO";
    ApplicationCountry["MR"] = "MR";
    ApplicationCountry["MS"] = "MS";
    ApplicationCountry["MT"] = "MT";
    ApplicationCountry["MU"] = "MU";
    ApplicationCountry["MW"] = "MW";
    ApplicationCountry["MX"] = "MX";
    ApplicationCountry["MY"] = "MY";
    ApplicationCountry["MZ"] = "MZ";
    ApplicationCountry["NA"] = "NA";
    ApplicationCountry["NE"] = "NE";
    ApplicationCountry["NG"] = "NG";
    ApplicationCountry["NI"] = "NI";
    ApplicationCountry["NL"] = "NL";
    ApplicationCountry["NP"] = "NP";
    ApplicationCountry["NO"] = "NO";
    ApplicationCountry["NZ"] = "NZ";
    ApplicationCountry["OM"] = "OM";
    ApplicationCountry["PA"] = "PA";
    ApplicationCountry["PE"] = "PE";
    ApplicationCountry["PG"] = "PG";
    ApplicationCountry["PH"] = "PH";
    ApplicationCountry["PK"] = "PK";
    ApplicationCountry["PL"] = "PL";
    ApplicationCountry["PT"] = "PT";
    ApplicationCountry["PW"] = "PW";
    ApplicationCountry["PY"] = "PY";
    ApplicationCountry["QA"] = "QA";
    ApplicationCountry["RO"] = "RO";
    ApplicationCountry["RU"] = "RU";
    ApplicationCountry["SA"] = "SA";
    ApplicationCountry["SB"] = "SB";
    ApplicationCountry["SC"] = "SC";
    ApplicationCountry["SE"] = "SE";
    ApplicationCountry["SG"] = "SG";
    ApplicationCountry["SI"] = "SI";
    ApplicationCountry["SK"] = "SK";
    ApplicationCountry["SL"] = "SL";
    ApplicationCountry["SN"] = "SN";
    ApplicationCountry["SR"] = "SR";
    ApplicationCountry["ST"] = "ST";
    ApplicationCountry["SV"] = "SV";
    ApplicationCountry["SZ"] = "SZ";
    ApplicationCountry["TC"] = "TC";
    ApplicationCountry["TD"] = "TD";
    ApplicationCountry["TH"] = "TH";
    ApplicationCountry["TJ"] = "TJ";
    ApplicationCountry["TM"] = "TM";
    ApplicationCountry["TN"] = "TN";
    ApplicationCountry["TR"] = "TR";
    ApplicationCountry["TT"] = "TT";
    ApplicationCountry["TW"] = "TW";
    ApplicationCountry["TZ"] = "TZ";
    ApplicationCountry["UA"] = "UA";
    ApplicationCountry["UG"] = "UG";
    ApplicationCountry["US"] = "US";
    ApplicationCountry["UY"] = "UY";
    ApplicationCountry["UZ"] = "UZ";
    ApplicationCountry["VC"] = "VC";
    ApplicationCountry["VE"] = "VE";
    ApplicationCountry["VG"] = "VG";
    ApplicationCountry["VN"] = "VN";
    ApplicationCountry["YE"] = "YE";
    ApplicationCountry["ZA"] = "ZA";
    ApplicationCountry["ZW"] = "ZW";
})(ApplicationCountry = exports.ApplicationCountry || (exports.ApplicationCountry = {}));
var ApplicationCountryHelpers = (function () {
    function ApplicationCountryHelpers() {
    }
    ApplicationCountryHelpers.isValid = function (value) {
        return ApplicationCountryHelpers.all.indexOf(value) >= 0;
    };
    ApplicationCountryHelpers.all = [
        ApplicationCountry.AE,
        ApplicationCountry.AG,
        ApplicationCountry.AI,
        ApplicationCountry.AL,
        ApplicationCountry.AM,
        ApplicationCountry.AO,
        ApplicationCountry.AR,
        ApplicationCountry.AT,
        ApplicationCountry.AU,
        ApplicationCountry.AZ,
        ApplicationCountry.BB,
        ApplicationCountry.BE,
        ApplicationCountry.BF,
        ApplicationCountry.BG,
        ApplicationCountry.BH,
        ApplicationCountry.BJ,
        ApplicationCountry.BM,
        ApplicationCountry.BN,
        ApplicationCountry.BO,
        ApplicationCountry.BR,
        ApplicationCountry.BS,
        ApplicationCountry.BT,
        ApplicationCountry.BW,
        ApplicationCountry.BY,
        ApplicationCountry.BZ,
        ApplicationCountry.CA,
        ApplicationCountry.CG,
        ApplicationCountry.CH,
        ApplicationCountry.CL,
        ApplicationCountry.CN,
        ApplicationCountry.CO,
        ApplicationCountry.CR,
        ApplicationCountry.CV,
        ApplicationCountry.CY,
        ApplicationCountry.CZ,
        ApplicationCountry.DE,
        ApplicationCountry.DK,
        ApplicationCountry.DM,
        ApplicationCountry.DO,
        ApplicationCountry.DZ,
        ApplicationCountry.EC,
        ApplicationCountry.EE,
        ApplicationCountry.EG,
        ApplicationCountry.ES,
        ApplicationCountry.FI,
        ApplicationCountry.FJ,
        ApplicationCountry.FM,
        ApplicationCountry.FR,
        ApplicationCountry.GB,
        ApplicationCountry.GD,
        ApplicationCountry.GH,
        ApplicationCountry.GM,
        ApplicationCountry.GR,
        ApplicationCountry.GT,
        ApplicationCountry.GW,
        ApplicationCountry.GY,
        ApplicationCountry.HK,
        ApplicationCountry.HN,
        ApplicationCountry.HR,
        ApplicationCountry.HU,
        ApplicationCountry.ID,
        ApplicationCountry.IE,
        ApplicationCountry.IL,
        ApplicationCountry.IN,
        ApplicationCountry.IS,
        ApplicationCountry.IT,
        ApplicationCountry.JM,
        ApplicationCountry.JO,
        ApplicationCountry.JP,
        ApplicationCountry.KE,
        ApplicationCountry.KG,
        ApplicationCountry.KH,
        ApplicationCountry.KN,
        ApplicationCountry.KR,
        ApplicationCountry.KW,
        ApplicationCountry.KY,
        ApplicationCountry.KZ,
        ApplicationCountry.LA,
        ApplicationCountry.LB,
        ApplicationCountry.LC,
        ApplicationCountry.LK,
        ApplicationCountry.LR,
        ApplicationCountry.LT,
        ApplicationCountry.LU,
        ApplicationCountry.LV,
        ApplicationCountry.MD,
        ApplicationCountry.MG,
        ApplicationCountry.MK,
        ApplicationCountry.ML,
        ApplicationCountry.MN,
        ApplicationCountry.MO,
        ApplicationCountry.MR,
        ApplicationCountry.MS,
        ApplicationCountry.MT,
        ApplicationCountry.MU,
        ApplicationCountry.MW,
        ApplicationCountry.MX,
        ApplicationCountry.MY,
        ApplicationCountry.MZ,
        ApplicationCountry.NA,
        ApplicationCountry.NE,
        ApplicationCountry.NG,
        ApplicationCountry.NI,
        ApplicationCountry.NL,
        ApplicationCountry.NP,
        ApplicationCountry.NO,
        ApplicationCountry.NZ,
        ApplicationCountry.OM,
        ApplicationCountry.PA,
        ApplicationCountry.PE,
        ApplicationCountry.PG,
        ApplicationCountry.PH,
        ApplicationCountry.PK,
        ApplicationCountry.PL,
        ApplicationCountry.PT,
        ApplicationCountry.PW,
        ApplicationCountry.PY,
        ApplicationCountry.QA,
        ApplicationCountry.RO,
        ApplicationCountry.RU,
        ApplicationCountry.SA,
        ApplicationCountry.SB,
        ApplicationCountry.SC,
        ApplicationCountry.SE,
        ApplicationCountry.SG,
        ApplicationCountry.SI,
        ApplicationCountry.SK,
        ApplicationCountry.SL,
        ApplicationCountry.SN,
        ApplicationCountry.SR,
        ApplicationCountry.ST,
        ApplicationCountry.SV,
        ApplicationCountry.SZ,
        ApplicationCountry.TC,
        ApplicationCountry.TD,
        ApplicationCountry.TH,
        ApplicationCountry.TJ,
        ApplicationCountry.TM,
        ApplicationCountry.TN,
        ApplicationCountry.TR,
        ApplicationCountry.TT,
        ApplicationCountry.TW,
        ApplicationCountry.TZ,
        ApplicationCountry.UA,
        ApplicationCountry.UG,
        ApplicationCountry.US,
        ApplicationCountry.UY,
        ApplicationCountry.UZ,
        ApplicationCountry.VC,
        ApplicationCountry.VE,
        ApplicationCountry.VG,
        ApplicationCountry.VN,
        ApplicationCountry.YE,
        ApplicationCountry.ZA,
        ApplicationCountry.ZW
    ];
    return ApplicationCountryHelpers;
}());
exports.ApplicationCountryHelpers = ApplicationCountryHelpers;
var irt_1 = require("@playq/irt");
irt_1.Introspector.register('net.playq.services.lenses.ApplicationCountry', {
    full: 'net.playq.services.lenses.ApplicationCountry',
    short: 'ApplicationCountry',
    package: 'net.playq.services.lenses',
    type: irt_1.IntrospectorTypes.Enum,
    options: ApplicationCountryHelpers.all
});
//# sourceMappingURL=ApplicationCountry.js.map